import React from "react";
import { Calendar, Location, Mail, Phone } from "../AdminIcons";

const Users = () => (
  <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.6667 17.3334V20H0V17.3334C0 17.3334 0 12 9.33333 12C18.6667 12 18.6667 17.3334 18.6667 17.3334ZM14 4.66672C14 3.74374 13.7263 2.84148 13.2135 2.07405C12.7007 1.30663 11.9719 0.708487 11.1192 0.355278C10.2665 0.0020692 9.32816 -0.0903464 8.42291 0.089718C7.51767 0.269782 6.68615 0.714239 6.0335 1.36688C5.38086 2.01953 4.9364 2.85105 4.75634 3.75629C4.57627 4.66154 4.66869 5.59985 5.0219 6.45257C5.3751 7.30529 5.97324 8.03413 6.74067 8.54691C7.5081 9.05969 8.41035 9.33338 9.33333 9.33338C10.571 9.33338 11.758 8.84172 12.6332 7.96655C13.5083 7.09138 14 5.90439 14 4.66672ZM18.5867 12C19.4063 12.6344 20.077 13.4406 20.5516 14.3621C21.0261 15.2835 21.293 16.2977 21.3333 17.3334V20H26.6667V17.3334C26.6667 17.3334 26.6667 12.4934 18.5867 12ZM17.3333 4.9062e-05C16.4157 -0.00421912 15.5184 0.270091 14.76 0.786716C15.5699 1.91836 16.0054 3.2751 16.0054 4.66672C16.0054 6.05833 15.5699 7.41507 14.76 8.54672C15.5184 9.06334 16.4157 9.33765 17.3333 9.33338C18.571 9.33338 19.758 8.84172 20.6332 7.96655C21.5083 7.09138 22 5.90439 22 4.66672C22 3.42904 21.5083 2.24205 20.6332 1.36688C19.758 0.491715 18.571 4.9062e-05 17.3333 4.9062e-05Z" fill="#923D8C"/>
</svg>

);

const Info = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
      fill="#923D8C"
    />
  </svg>
);
    


const ContactItem = ({ label, icon: Icon, value }) => (
  <div className="flex min-w-0 gap-3 desktop:gap-4">
    <div className="flex w-[30px] shrink-0 items-start justify-center pt-0.5">
      {Icon ? <Icon /> : null}
    </div>
    <div className="min-w-0">
      <p className="text-xl leading-7 text-[#484848] desktop:text-2xl">{label}</p>
      <p className="break-words text-lg leading-[23px] text-[#2D2D2D] desktop:text-xl">{value}</p>
    </div>
  </div>
);

const InstructorProfileInformation = ({
  profileInformation = {},
}) => {
  const email = profileInformation?.email || "";
  const phone = profileInformation?.phoneNumber || "";
  const location = profileInformation?.location || "";
  const totalStudents = profileInformation?.totalStudents || "";
  const joinedDate = profileInformation?.createdAt
  ? new Date(profileInformation.createdAt)
      .toLocaleDateString("en-GB")
      .split("/")
      .join("-")
  : "";
  const bio = profileInformation?.bio || "";
  return (
    <section className="rounded-xl border border-[#60555557] bg-white px-4 pb-6 pt-5 sm:pl-6 sm:pr-4 sm:pb-7 sm:pt-6 desktop:pl-9">
      <h3 className="text-xl font-medium leading-[23px] text-black">
        Profile Information
      </h3>

      <div className="mt-[14px] grid grid-cols-1 gap-5 pl-0 sm:gap-6 sm:pl-4 lg:grid-cols-2 desktop:pl-7">
        <div className="space-y-5 desktop:space-y-[29px]">
          <ContactItem label="Email" icon={Mail} value={email} />
          <ContactItem label="Joined Date" icon={Calendar} value={joinedDate} />
        </div>

        <div className="space-y-5 sm:ml-0 lg:ml-6 desktop:ml-14 desktop:space-y-6">
          <ContactItem label="Phone" icon={Phone} value={phone} />
        </div>
      </div>

      <div className="mt-5 pl-0 sm:pl-4 desktop:pl-7">
        <ContactItem label="Bio" icon={Info} value={bio} />
      </div>
    </section>
  );
};

export default InstructorProfileInformation;
